import axios from "axios";
import Config from "src/config";

const v1_actionEnviarArquivoBuffer = (querys, formData) => {
    return axios({
        method: "post",
        url:`${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/enviar-arquivo-buffer${querys}`,
        data:formData
    });
};

export default v1_actionEnviarArquivoBuffer;
